// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"drawer_backdrop__YyGPH","container":"drawer_container___aMO9","open":"drawer_open__1ifBX"};